import {ajaxRest} from './ajaxBase'

const CONTROLLER_PREFIX = 'test'
const RESTFUL_API_VER = 'v1.0'

function restfulTest (param) {
  let p = new Promise((resolve, reject) => {
    let params = {
      url: `/${RESTFUL_API_VER}/${CONTROLLER_PREFIX}/hello`,
      method: 'GET',
      data: {
        param: param
      },
      timeout: {client: 10 * 1000}
    }

    ajaxRest(params).then(data => {
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })

  return p
}

export default {restfulTest}



// WEBPACK FOOTER //
// ./src/api/globalAPI.js